export const CHANGE_COLORS = "CHANGE COLORS";
export const CHANGE_DIRECTION = "CHANGE DIRECTION";
export const CHANGE_BACKGROUND = "CHANGE BACKGROUND";
